export const getMaxItemsWithoutScroll = (
  isWinterResort: boolean,
  { isBrowserGreaterThan }: ResponsiveProps,
) => {
  if (isBrowserGreaterThan.L) {
    if (isWinterResort) {
      return 2;
    }

    return 4;
  }

  if (isBrowserGreaterThan.M) {
    if (isWinterResort) {
      return 2;
    }

    return 3;
  }

  return 0;
};
